<template>
  <div
    :data-uid="section.uid"
    :class="`--${sid}--element`"
  >
    <highliter
      v-model="section.name"
      :dublicate="section"
      :dublicate-deep="parentUID"
      class="highlight-element w-auto"
      section-type="element"
      @delete="$emit('delete')"
      @dublicate="$emit('dublicate')"
      @favorite="$emit('favorite', $el)"
      @flow="handleFlow"
      @move-to="to => $emit('move-to', to)"
      @add-subject="$emit('add-subject')"
      @click.stop.native="sectionSettings('richText')"
    >
      <RichTextContentEditable
        v-model="section.options.content.richText.text"
        :variables="variablesText"
        @input="val => section.options.content.richText.text = val"
      />
    </highliter>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import SectionMixin from '@builder/components/mixins/SectionMixin'
import RichTextContentEditable from '@/components/builder/utils/RichTextContentEditable.vue'
import Highliter from '@builder/components/builder/utils/Highliter'
import {toJSON} from '@/utils/helpers'

export default {
  name: 'ElRichText',
  components: {
    RichTextContentEditable,
    Highliter
  },
  mixins: [SectionMixin],
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    variables () {
      const gv = toJSON(this.project.variables)

      if (Array.isArray(gv?.variables)) {
        return gv?.variables
      }

      const object = gv?.variables || {}
      const list = Object.entries(object).map(([key, value]) => ({
        ...value,
        hash: key
      }))

      return list
    },
    variablesText () {
      return this.variables.filter(variable => variable.type === 'text')
    }
  }
}
</script>